import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { WebStat } from '@miro-site/stats';
export var initEventHub = function initEventHub(params) {
  var handler = WebStat.createStatHandler({
    apiHost: params.apiHost,
    library: 'miro-site/analytics',
    version: '0.0.1',
    addCommonStatParams: function addCommonStatParams(params) {
      return _objectSpread({}, params);
    },
    sendError: function sendError(err, extra) {
      return console.error(err, extra);
    }
  }); // Expose global methods to use in GTM

  window.analytics = {
    identify: function identify(id) {
      WebStat.identify(handler, params.apiKey, {
        id: id,
        name: '',
        email: ''
      });
    },
    page: function page() {
      WebStat.page(handler, params.apiKey);
    },
    track: function track(eventName, properties) {
      var cleanProps; // sometimes properties are passed as strings

      if (typeof properties === 'string') {
        var trimmedStringProp = properties.trim();

        if (trimmedStringProp.length > 0) {
          cleanProps = _defineProperty({}, trimmedStringProp, trimmedStringProp);
        }
      } else {
        cleanProps = properties;
      }

      WebStat.track(handler, params.apiKey, eventName, cleanProps);
    }
  };
};